import {
  PATHNAME_APP,
  PATHNAME_CANVAS,
  PATHNAME_COMPONENT,
  PATHNAME_CONTRACT,
  PATHNAME_FOLDER,
  PATHNAME_LOGIN,
  PATHNAME_LOGOUT,
  PATHNAME_NAUTH,
  PATHNAME_PAGE,
  PATHNAME_REPORTS,
  PATHNAME_ROOT,
  PATHNAME_SEARCH,
  PATHNAME_VERSION,
  VISITED_APP,
  VISITED_CANVAS,
  VISITED_COMPONENT,
  VISITED_CONTRACT,
  VISITED_FOLDER,
  VISITED_LOGIN,
  VISITED_LOGOUT,
  VISITED_NAUTH,
  VISITED_PAGE,
  VISITED_REPORTS,
  VISITED_ROOT,
  VISITED_SEARCH,
  VISITED_VERSION
} from './const';
import {
  appThunk,
  componentThunk,
  contractThunk,
  folderThunk,
  loginThunk,
  logoutThunk,
  nauthThunk,
  pageThunk,
  reportThunk,
  searchThunk
} from './routesThunks';

export default {
  [VISITED_APP]: {
    path: PATHNAME_APP,
    thunk: appThunk
  },
  [VISITED_CANVAS]: PATHNAME_CANVAS,
  [VISITED_COMPONENT]: {
    path: PATHNAME_COMPONENT,
    thunk: componentThunk
  },
  [VISITED_CONTRACT]: {
    path: PATHNAME_CONTRACT,
    thunk: contractThunk
  },
  [VISITED_FOLDER]: {
    path: PATHNAME_FOLDER,
    thunk: folderThunk
  },
  [VISITED_LOGIN]: {
    path: PATHNAME_LOGIN,
    thunk: loginThunk
  },
  [VISITED_LOGOUT]: {
    path: PATHNAME_LOGOUT,
    thunk: logoutThunk
  },
  [VISITED_NAUTH]: {
    path: PATHNAME_NAUTH,
    thunk: nauthThunk
  },
  [VISITED_PAGE]: {
    path: PATHNAME_PAGE,
    thunk: pageThunk
  },
  [VISITED_REPORTS]: {
    path: PATHNAME_REPORTS,
    thunk: reportThunk
  },
  [VISITED_ROOT]: {
    path: PATHNAME_ROOT,
    thunk: loginThunk
  },
  [VISITED_SEARCH]: {
    path: PATHNAME_SEARCH,
    thunk: searchThunk
  },
  [VISITED_VERSION]: PATHNAME_VERSION
};
